import React, { lazy, Suspense } from 'react';
import { lazily } from 'react-lazily';

import { IconVariants } from 'core/generic/elements/icons';

import styles from './buttons-toggler.module.scss';

type ButtonsTogglerProps = {
	id?: string;
	trueLabel: string;
	falseLabel: string;
	errorMessage: string;
	errorIcon?: IconVariants;
	value: boolean | undefined;
	onChange: (value: boolean | undefined) => void;
};

const Button = lazy(() => import('core/generic/elements/button'));

const { Error } = lazily(() => import('core/generic/elements/form'));

export const ButtonsToggler = ({
	id,
	trueLabel,
	falseLabel,
	value = undefined,
	errorMessage = '',
	errorIcon,
	onChange,
}: ButtonsTogglerProps) => {
	return (
		<Suspense fallback={null}>
			<>
				<div className={styles.buttons} id={id}>
					<Button
						type="button"
						label={trueLabel}
						variant={value === true ? 'secondary' : 'tertiary'}
						className={styles.submitButton}
						onClick={() =>
							value === true
								? onChange(undefined)
								: onChange(true)
						}
					/>
					<Button
						type="button"
						label={falseLabel}
						variant={value === false ? 'secondary' : 'tertiary'}
						className={styles.submitButton}
						onClick={() =>
							value === false
								? onChange(undefined)
								: onChange(false)
						}
					/>
				</div>
				{errorMessage && <Error text={errorMessage} icon={errorIcon} />}
			</>
		</Suspense>
	);
};
